export const colors = {
    red: '#b82f3f',
    blue: '#52C0EE',
    black: 'black',
    green: "#76C258",
    greenRgba: "118, 194, 88",
    white: "white",
}